import {IconButton} from 'shells/button/icon-button/icon-button';
import {LayoutRegularIcon} from 'shells/icon/svg/layout-regular-icon';

import {appHistory} from '../../../history';
import {useDismissibleUserSetting} from '../../../util/hooks/use-dismissible-user-setting';

import {getLayoutCustomizerPath, getLayoutCustomizerViewedSetting} from './helpers';

import styles from './customize-layout-button.module.css';

interface Props {
    text: string;
    entityType: 'LEAD' | 'CONTACT' | 'ACCOUNT';
    stagesetId?: string;
}

export function CustomizeLayoutButton(props: Props) {
    const {shouldShow, onDismiss} = useDismissibleUserSetting(
        getLayoutCustomizerViewedSetting(props.entityType)
    );

    const path = getLayoutCustomizerPath(props.entityType, props.stagesetId);

    return (
        <div className={styles['customize-layout-button']}>
            <IconButton
                text={props.text}
                icon={LayoutRegularIcon}
                onClick={() => {
                    appHistory.push(path);

                    if (onDismiss) {
                        onDismiss();
                    }
                }}
                badgeProps={{
                    shouldShow,
                    color: 'orange',
                    shouldFlash: true,
                }}
            />
        </div>
    );
}
